import styled from "styled-components";
import { px2rem } from "common/helpers/rem";
import { useOpacityHoverStyle } from "common/components/designSystem/styles";

export const EngageWrapper = styled.div`
  width: 100%;
  height: ${px2rem(42)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
`;


export const ItemWrapper = styled.div.attrs({role: "button"})`
  width: fit-content;
  transition: opacity 200ms ease-in;
    height: ${px2rem(24)};

  &:hover {
    ${useOpacityHoverStyle}
  }
`;
